import {
  TLanguage,
  languages as _languages,
  enCommonsTranslations,
  frCommonsTranslations,
  frenchProcessor,
} from '@geovelo-frontends/commons';
import i18n, { ResourceKey } from 'i18next';
import { merge } from 'lodash';
import { initReactI18next } from 'react-i18next';

import en from '../translations/en.json';
import fr from '../translations/fr.json';

export type TAppLanguage = TLanguage;

export const languages: {
  [key in TAppLanguage]?: {
    key: TAppLanguage;
    translation: ResourceKey;
    icon: React.JSX.Element;
    label: string;
  };
} = {
  fr: { ..._languages['fr'], key: 'fr', translation: merge(frCommonsTranslations, fr) },
  en: { ..._languages['en'], key: 'en', translation: merge(enCommonsTranslations, en) },
};

i18n
  .use(initReactI18next)
  .use(frenchProcessor)
  .init({
    resources: languages,
    lng: 'fr',
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    postProcess: [`frenchProcessor`],
  });

export default i18n;
